import React, { useState, useEffect, useRef } from "react"
import "./technologies.scss"
import GetTechnologiesImgs from "./../../hooks/getTechnologies/getTechnologiesImg"
import ImgReveal from "./../blockrevealimg/imgReveal"
import { gsap,Power3 } from "gsap"

const Technologies = () => {
  const [reveal, setreveal] = useState(false)
  const technologies = GetTechnologiesImgs()

  const titleRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    gsap.from(titleRef.current, {
      duration: 1,
      x: "+300",
      opacity: 0,
      ease: Power3.easeIn,
      scrollTrigger: {
        trigger: titleRef.current,
        start: "top 90%",
      },
    })

    gsap.to(buttonRef.current, {
      duration: 1.2,
      zoom: 0.5,
      ease: "ease-in-out",
      repeat: -1,
      yoyo: true
    })
  }, [])

  return (
    <section id="technologies" className="container competencies-section">
      <h2 ref={titleRef} className="competencies-title no-select">
        TECHNOLOGIES
      </h2>

      <div className={`competencies ${reveal ? "reveal" : ""}`}>
        <div className="competencies-container">
          {technologies.map(technoligie => (
            <img
              className="technologie-img no-select"
              src={technoligie.node.publicURL}
              alt={technoligie.node.name}
              key={technoligie.node.id}
            />
          ))}
        </div>
        <div
          className="block-reveal"
          role="button"
          onClick={() => setreveal(!reveal)}
        >
          <ImgReveal>
            <div ref={buttonRef} className="touch-me-container">
              <span className="no-select"> Touch Me </span>
            </div>
          </ImgReveal>
        </div>
        <div className={`competencies-description ${reveal ? "show" : ""}`}>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda
            reiciendis quos voluptate similique iusto voluptatum accusantium
            saepe delectus facere! Consectetur, expedita eius!
          </p>
        </div>
      </div>
    </section>
  )
}

export default Technologies
